import { File } from "components/icons/generated";
import LinkButton, { LinkButtonProps } from "ds/components/Button/LinkButton";
import { AnalyticsCommonProps } from "hooks/useAnalytics";
import { DocsUrl } from "utils/getDocsUrl";
import DesktopView from "components/Mobile/DesktopView";

import styles from "./styles.module.css";

type DocumentationButtonProps = {
  to: DocsUrl;
  label?: string;
  size?: LinkButtonProps["size"];
} & AnalyticsCommonProps;

const DocumentationButton = ({
  to,
  analyticsProps,
  analyticsPage,
  analyticsTitle,
  label = "Full documentation",
  size = "medium",
}: DocumentationButtonProps) => {
  return (
    <DesktopView>
      <LinkButton
        href={to}
        variant="secondary"
        size={size}
        target="_blank"
        startIcon={File}
        className={styles.documentationButton}
        analyticsTitle={analyticsTitle || `${label} Click`}
        analyticsProps={analyticsProps}
        analyticsPage={analyticsPage}
      >
        {label}
      </LinkButton>
    </DesktopView>
  );
};

export default DocumentationButton;
